module.exports = __webpack_public_path__ + "static/media/face1a.cded9488.jpg";